export enum LOCATION_STATUS {
  ACTIVE = 'A',
  BLOCKED = 'B',
}

export interface LocationData {
  locationId: string;
  locationName: string;
  locationTitle: string;
  locationEngTitle: string;
  locationImage: string;
  locationSubtitle: string;
  status: LOCATION_STATUS;
  clubCount: number;
  totalRecords: number;
  totalClubs: string;
  pageNo: number;
  recordPerPage: number;
  longitude: string;
  latitude: string;
  locationURL: string;
}

export interface LocationParams {
  row?: number;
  fetch?: number;
  pageNo?: number;
  search?: string;
}

// API_ACTION_TYPES
